module.exports = __webpack_public_path__ + "media/images/front/icons/groups-432f2e34bcd9e8101d808ba9a1535622.png";